import {type WCPHPData} from '../../../@type/woocommerce/php-data';
import spinnerImageURL from '../../../express-checkout/img/spinner.svg';

declare const peachpay_data: WCPHPData;

function peachpayButtonTemplate() {
	return /* html */`
	<div class="pp-break"></div>
	<div id="pp-button-container" class="button-container pp-button-container ${(peachpay_data.test_mode && !peachpay_data.wp_admin_or_editor) ? 'hide' : ''}">
		<div id="pp-stripe-payment-request-wrapper" style="width: 220px;">
			<div id="pp-stripe-payment-request-btn" style="width: 100%; margin: 5px 0; display: none;">
		</div>
		</div>
		<button id="pp-button" class="pp-button ${peachpay_pageTypeClass()} ${peachpay_data.button_custom_classes}" type="button" style="display: block;">
			<svg id="loading-spinner" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.0" viewBox="0 0 128 128" xml:space="preserve" class="pp-spinner"><g><circle cx="16" cy="64" r="16" fill-opacity="1"/><circle cx="16" cy="64" r="16" fill-opacity="0.67" transform="rotate(45,64,64)"/><circle cx="16" cy="64" r="16" fill-opacity="0.42" transform="rotate(90,64,64)"/><circle cx="16" cy="64" r="16" fill-opacity="0.2" transform="rotate(135,64,64)"/><circle cx="16" cy="64" r="16" fill-opacity="0.12" transform="rotate(180,64,64)"/><circle cx="16" cy="64" r="16" fill-opacity="0.12" transform="rotate(225,64,64)"/><circle cx="16" cy="64" r="16" fill-opacity="0.12" transform="rotate(270,64,64)"/><circle cx="16" cy="64" r="16" fill-opacity="0.12" transform="rotate(315,64,64)"/><animateTransform attributeName="transform" type="rotate" values="0 64 64;315 64 64;270 64 64;225 64 64;180 64 64;135 64 64;90 64 64;45 64 64" calcMode="discrete" dur="800ms" repeatCount="indefinite"></animateTransform></g></svg>
			<div id="pp-button-content">
				<span id="pp-button-text">${peachpay_data.button_text}</span>
				<svg id="button-icon-regular" class="" viewBox="0 0 0 0"></svg>
			</div>
		</button>
		<div id="payment-methods-container" class="cc-company-logos">
            ${peachpay_data.button_available_icons}
		</div>
	</div>
	<div class="pp-break"></div>`;
}

function peachpayMobileButtonTemplate() {
	return /* html */`
	<div id="pp-button-container" style="background-color:#21105d;" class="pp-mobile-product-page-button">
		<div id="pp-stripe-payment-request-wrapper" style="width: 100%; margin: 5px 0; display: none;">
		</div>
		<button id="pp-button" class="pp-button ${peachpay_pageTypeClass()}" type="button" style="display: block;">
			<object
				type="image/svg+xml"
				data="${peachpay_data.plugin_asset_url}public/dist/${spinnerImageURL}"
				id="loading-spinner"
				class="pp-spinner"
				height="20"
				width="20">
			</object>
			<div id="pp-button-content">
				<span id="pp-button-text">${peachpay_data.button_text}</span>
				<svg id="button-icon-regular" class="" viewBox="0 0 0 0"></svg>
			</div>
		</button>
	</div>`;
}

function peachpayMiniButtonTemplate() {
	return /* html */`
	<div class="pp-break"></div>
	<div id="pp-button-container-mini" class="button-container pp-button-container ${(peachpay_data.test_mode && !peachpay_data.wp_admin_or_editor) ? 'hide' : ''}">
		<button id="pp-button-mini" class="pp-button ${peachpay_data.disable_default_font_css === '1' ? '' : 'pp-button-default-font'} ${peachpay_pageTypeClass()} ${peachpay_data.button_custom_classes}" type="button" style="display: block;">
			<div id="pp-button-content-mini">
				<span id="pp-button-text-mini">${peachpay_data.button_text}</span>
				<svg id="button-icon-minicart" class="" viewBox="0 0 0 0"></svg>
			</div>
		</button>
		<div id="payment-methods-container-minicart" class="cc-company-logos">
            ${peachpay_data.button_available_icons}
		</div>
	</div>
	<div class="pp-break"></div>
	`;
}

/**
 * Helper function to insert a css class for page specific styles on the PeachPay button.
 */
function peachpay_pageTypeClass(): string {
	if (peachpay_data.is_cart_page) {
		return 'pp-cart-page';
	}

	if (peachpay_data.is_checkout_page) {
		return 'pp-product-page';
	}

	if (peachpay_data.is_shop_page) {
		return 'pp-shop-page';
	}

	return 'pp-product-page';
}

export {
	peachpayButtonTemplate,
	peachpayMobileButtonTemplate,
	peachpayMiniButtonTemplate,
};
